import { render } from "./Messages.vue?vue&type=template&id=7fab4f0c&scoped=true"
import script from "./Messages.vue?vue&type=script&lang=js"
export * from "./Messages.vue?vue&type=script&lang=js"

import "./Messages.vue?vue&type=style&index=0&id=7fab4f0c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7fab4f0c"

export default script